var links = $('.activeLetter');
var divs = $('.letterDisplay');
links.click(function letterFIlter(event){
    divs.fadeOut();
    if (event.target.id !== 'showAll') {
        divs.filter('.' + event.target.id).fadeIn();
    } else {
        divs.fadeIn();
    }
});